import blankAvatar from '@/assets/images/blank-avatar-300x300.png';
import { MinusIcon } from '@/assets/SVGs/icons/MinusIcon';
import AppBade from '@/components/ui/AppBade';
import AppButton from '@/components/ui/AppButton';
import { AppCard } from '@/components/ui/AppCard';
import AppTable from '@/components/ui/AppTable';
import { axiosGetRequest } from '@/services/Request';
import { useQuery } from '@tanstack/react-query';

import AppAvatar from '../components/ui/AppAvatar';
import { CheckedIcon } from '@/assets/SVGs/icons/CheckedIcon';
import { useState } from 'react';
import { AppLineChart } from '@/components/charts/pieChart/AppLineChart';
import { AppBarChart } from '@/components/charts/pieChart/AppBarChart';
import { endpoints } from '@/services/endpoints';
function Elements() {
  const [page, setPage] = useState(1);
  const {
    data: usersData,
    isLoading,
    isSuccess,
  } = useQuery({
    queryKey: ['all-users', page],
    queryFn: () =>
      axiosGetRequest(`api/v2/users/get-all-users/`, {
        page,
      }),

    select: data => ({
      result: data.result,
      totalPages: data.pagination.totalPages,
    }),
  });

  const handlePages = (pageNumber: number) => {
    setPage(pageNumber);
  };

  const { data: allTypes } = useQuery({
    queryKey: ['ticketsType'],
    queryFn: () => axiosGetRequest(endpoints.getTicketByType),
    select: allTypes => allTypes.data,
  });
  console.log('alltypes: ', allTypes);

  return (
    <div>
      {/* charts  */}
      <AppCard className="mb-4">
        <h3 className="mb-2 text-lg font-medium">Line Chart</h3>
        <AppLineChart
          chartData={[
            {
              count: 3,
              month: 'April',
              year: 2025,
            },
            {
              count: 3,
              month: 'February',
              year: 2025,
            },
            {
              count: 6,
              month: 'March',
              year: 2025,
            },
            {
              count: 1,
              month: 'May',
              year: 2025,
            },
          ]}
          dataKey="count"
          nameKey="month"
          config={{
            count: {
              label: 'Total Count',
              color: '#ff5757',
            },
            // April: {
            //   label: "April 2025",
            //   color: "#4caf50",
            // },
            // February: {
            //   label: "Feb 2025",
            //   color: "#2196f3",
            // },
            // March: {
            //   label: "March 2025",
            //   color: "#ff9800",
            // },
            // May: {
            //   label: "May 2025",
            //   color: "#9c27b0",
            // },
          }}
        />
      </AppCard>

      <AppCard className="mb-4">
        <h3 className="mb-2 text-lg font-medium">Bar Chart</h3>
        <AppBarChart
          chartData={[
            {
              count: 3,
              month: 'April',
              year: 2025,
            },
            {
              count: 3,
              month: 'February',
              year: 2025,
            },
            {
              count: 6,
              month: 'March',
              year: 2025,
            },
            {
              count: 1,
              month: 'May',
              year: 2025,
            },
          ]}
          dataKey="count"
          nameKey="month"
          config={{
            count: {
              label: 'Total Count',
              color: '#ff5757',
            },
            April: {
              label: 'April 2025',
              color: '#4caf50',
            },
            February: {
              label: 'Feb 2025',
              color: '#2196f3',
            },
            March: {
              label: 'March 2025',
              color: '#ff9800',
            },
            May: {
              label: 'May 2025',
              color: '#9c27b0',
            },
          }}
        />
      </AppCard>

      <AppCard>
        <h3 className="mb-2 text-lg font-medium">Trail</h3>
        <AppBarChart
          chartData={allTypes}
          dataKey="count"
          nameKey="type"
          config={{
            count: {
              label: 'total count',
              color: '#0f0',
            },

            chat: {
              label: 'chat',
              color: '#4caf50',
            },
            bug: {
              label: 'bug',
              color: '#2196f3',
            },
            user: {
              label: 'user',
              color: '#ff9800',
            },
            book: {
              label: 'book',
              color: '#9c27b0',
            },
          }}
        />
      </AppCard>
      {/* ------- buttons -------  */}
      <AppButton size="sm" type="button">
        button
      </AppButton>
      {/* ------- Avatars -------  */}
      <AppAvatar src={blankAvatar} />
      {/* TABLE */}
      <AppCard>
        <AppTable
          tableButtonContent="add user"
          hasPagination
          header={[
            { name: 'user name', key: 'fullName' },
            { name: 'isActive', key: 'isActive' },
          ]}
          currentPage={page}
          handlePages={handlePages}
          totalPages={usersData?.totalPages}
          data={isSuccess && usersData.result}
          isLoading={isLoading}
        />
      </AppCard>
      {/* ---------- cards ---------- */}
      <AppCard className="my-2">dd</AppCard>
      <AppCard>
        <AppBade variant="label" color="error">
          default
        </AppBade>
        <AppBade variant="label" color="primary">
          default
        </AppBade>
        <AppBade variant="label" color="info">
          default
        </AppBade>
        <AppBade variant="label" color="warning">
          default
        </AppBade>
        <AppBade circle size="small" variant="label" color="error" iconOnly icon={MinusIcon}>
          ddd
        </AppBade>
        <AppBade circle size="small" variant="label" color="success" iconOnly icon={CheckedIcon}>
          ddd
        </AppBade>
      </AppCard>
    </div>
  );
}
export default Elements;
